import { useTranslation } from "react-i18next";
import { Panel } from 'primereact/panel';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { Chip } from "primereact/chip";
import { useState, useRef } from "react";
import { DataScroller } from 'primereact/datascroller';
import { Button } from "primereact/button";
import { Card } from "primereact/card";

export default function AcoesCompleta({
  acoes,
  isConsultaNova,
}: {
  acoes: any;
  isConsultaNova?: boolean;
}) {
  const { t } = useTranslation();
  const ds = useRef<DataScroller>(null);
  const [loader, setLoader] = useState<number>(10);
  const [expandedIdx, setExpandedIdx] = useState<number | null>(null);

  const formatDateToBR = (dateString: string) => {
    if (!dateString) return 'Não Informado';
    try {
      const date = new Date(dateString);
      return date.toLocaleDateString('pt-BR');
    } catch {
      return dateString;
    }
  };

  const displayResumos = (() => {
    if (acoes && acoes.length > 0 && acoes[0].resumos) return acoes[0].resumos;
    if (!acoes) return [];
    let totalValor = 0;
    const justicas = new Set();
    const comarcas = new Set();
    acoes.forEach((acao: any) => {
      if (acao.valor) {
        try {
          const val = parseFloat(acao.valor.replace(/\./g, '').replace(',', '.'));
          if (!isNaN(val)) totalValor += val;
        } catch (e) { }
      }
      if (acao.origem) justicas.add(acao.origem);
      if (acao.comarca) comarcas.add(acao.comarca);
    });
    return [
      { label: 'Quantidade', value: acoes.length, icon: 'pi pi-chart-bar' },
      { label: 'Valor Total', value: totalValor.toLocaleString('pt-BR', { minimumFractionDigits: 2 }), icon: 'pi pi-dollar' },
      { label: 'Justiças', value: justicas.size, icon: 'pi pi-building' },
      { label: 'Comarcas', value: comarcas.size, icon: 'pi pi-map-marker' },
    ];
  })();

  if (isConsultaNova) {
    return (
      <div
        style={{
          backgroundColor: '#FFFFFF',
          borderRadius: '16px',
          border: '1px solid #E5E7EB',
          boxShadow: '0 4px 20px -2px rgba(0,0,0,0.05)',
          padding: '24px',
        }}
      >
        {/* Header */}
        <div style={{ display: 'flex', alignItems: 'center', gap: '12px', marginBottom: '20px' }}>
          <div
            style={{
              backgroundColor: '#FEF2F2',
              borderRadius: '10px',
              padding: '10px',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
            }}
          >
            <i className="pi pi-briefcase" style={{ color: '#DC2626', fontSize: '18px' }} />
          </div>
          <div>
            <h3 style={{ fontSize: '1rem', fontWeight: 700, margin: 0, color: '#1E3A8A' }}>
              {t('acoesCompleta')}
            </h3>
            <span style={{ fontSize: 'small', color: '#6B7280' }}>
              {acoes?.length || 0} ação/ações encontrada{acoes?.length !== 1 ? 's' : ''}
            </span>
          </div>
        </div>

        {/* Summary cards */}
        <div
          style={{
            display: 'grid',
            gridTemplateColumns: 'repeat(auto-fit, minmax(140px, 1fr))',
            gap: '12px',
            marginBottom: '24px',
          }}
        >
          {displayResumos.map((item: any, idx: number) => (
            <div
              key={idx}
              style={{
                backgroundColor: '#1E3A8A',
                borderRadius: '12px',
                padding: '14px 16px',
                display: 'flex',
                justifyContent: 'space-between',
                alignItems: 'center',
              }}
            >
              <div style={{ display: 'flex', flexDirection: 'column', gap: '2px' }}>
                <span style={{ color: '#93C5FD', fontSize: '0.7rem', fontWeight: 700, textTransform: 'uppercase' }}>
                  {item.label}
                </span>
                <span style={{ color: '#FFFFFF', fontWeight: 800, fontSize: '1.1rem' }}>{item.value}</span>
              </div>
              <span
                style={{
                  backgroundColor: 'rgba(255,255,255,0.15)',
                  borderRadius: '50%',
                  width: '32px',
                  height: '32px',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                }}
              >
                <i className={item.icon} style={{ color: '#FFFFFF', fontSize: '14px' }} />
              </span>
            </div>
          ))}
        </div>

        {/* Ações table */}
        <div style={{ overflowX: 'auto', borderRadius: '10px', border: '1px solid #F3F4F6' }}>
          <table style={{ width: '100%', borderCollapse: 'collapse', textAlign: 'left', fontSize: 'small' }}>
            <thead>
              <tr style={{ backgroundColor: '#F9FAFB', borderBottom: '2px solid #E5E7EB' }}>
                {[t('processo'), t('autor'), t('comarca'), t('foro'), t('vara'), t('cidadeUF'), t('valor'), t('dataDistribuicao'), t('tipo'), t('origem')].map(h => (
                  <th
                    key={h}
                    style={{
                      padding: '10px 14px',
                      fontWeight: 700,
                      color: '#6B7280',
                      fontSize: '0.7rem',
                      textTransform: 'uppercase',
                      letterSpacing: '0.04em',
                      whiteSpace: 'nowrap',
                    }}
                  >
                    {h}
                  </th>
                ))}
              </tr>
            </thead>
            <tbody>
              {acoes && acoes.slice(0, loader).map((acao: any, idx: number) => (
                <>
                  <tr
                    key={idx}
                    onClick={() => setExpandedIdx(expandedIdx === idx ? null : idx)}
                    style={{
                      borderBottom: '1px solid #F3F4F6',
                      cursor: 'pointer',
                      transition: 'background-color 0.15s ease',
                    }}
                    onMouseEnter={e => (e.currentTarget.style.backgroundColor = '#F9FAFB')}
                    onMouseLeave={e => (e.currentTarget.style.backgroundColor = expandedIdx === idx ? '#EFF6FF' : 'transparent')}
                  >
                    <td style={{ padding: '10px 14px', color: '#1D4ED8', fontWeight: 600 }}>{acao.numero}</td>
                    <td style={{ padding: '10px 14px', color: '#374151' }}>
                      {acao.partes?.find((p: any) => p.polo === 'ATIVO' || p.polo === 'AUTOR')?.nome || '—'}
                    </td>
                    <td style={{ padding: '10px 14px', color: '#374151' }}>{acao.comarca}</td>
                    <td style={{ padding: '10px 14px', color: '#374151' }}>{acao.foro}</td>
                    <td style={{ padding: '10px 14px', color: '#374151' }}>{acao.vara}</td>
                    <td style={{ padding: '10px 14px', color: '#374151', whiteSpace: 'nowrap' }}>{acao.cidadeUF}</td>
                    <td style={{ padding: '10px 14px', color: '#DC2626', fontWeight: 700, whiteSpace: 'nowrap' }}>{acao.valor || '—'}</td>
                    <td style={{ padding: '10px 14px', color: '#374151', whiteSpace: 'nowrap' }}>{acao.dataDistribuicao}</td>
                    <td style={{ padding: '10px 14px' }}>
                      <span style={{ backgroundColor: '#F3F4F6', color: '#374151', fontSize: '0.7rem', fontWeight: 700, padding: '2px 8px', borderRadius: '4px', whiteSpace: 'nowrap' }}>
                        {acao.tipo}
                      </span>
                    </td>
                    <td style={{ padding: '10px 14px' }}>
                      <span
                        style={{
                          backgroundColor: acao.origem === 'FEDERAL' ? '#EFF6FF' : '#F0FDF4',
                          color: acao.origem === 'FEDERAL' ? '#1D4ED8' : '#15803D',
                          fontSize: '0.7rem',
                          fontWeight: 700,
                          padding: '2px 8px',
                          borderRadius: '4px',
                          whiteSpace: 'nowrap',
                        }}
                      >
                        {acao.origem}
                      </span>
                    </td>
                  </tr>
                  {/* Expandable detail row */}
                  {expandedIdx === idx && acao.partes && (
                    <tr key={`detail-${idx}`} style={{ backgroundColor: '#EFF6FF' }}>
                      <td colSpan={10} style={{ padding: '12px 20px' }}>
                        <div style={{ fontSize: '0.8rem', color: '#374151' }}>
                          <strong style={{ color: '#1E3A8A' }}>Partes:</strong>
                          <div style={{ display: 'flex', flexWrap: 'wrap', gap: '8px', marginTop: '6px' }}>
                            {acao.partes.map((parte: any, pIdx: number) => (
                              <span
                                key={pIdx}
                                style={{
                                  backgroundColor: '#DBEAFE',
                                  color: '#1E40AF',
                                  fontSize: '0.75rem',
                                  padding: '3px 10px',
                                  borderRadius: '20px',
                                  fontWeight: 500,
                                }}
                              >
                                <b>{parte.polo}:</b> {parte.nome}
                              </span>
                            ))}
                          </div>
                        </div>
                      </td>
                    </tr>
                  )}
                </>
              ))}
            </tbody>
          </table>
        </div>

        {/* Load more */}
        {acoes && acoes.length > loader && (
          <div style={{ marginTop: '12px', textAlign: 'center' }}>
            <button
              onClick={() => setLoader(loader + 10)}
              style={{
                background: 'none',
                border: '1px solid #E5E7EB',
                borderRadius: '8px',
                padding: '8px 20px',
                cursor: 'pointer',
                color: '#1E3A8A',
                fontWeight: 600,
                fontSize: 'small',
                display: 'inline-flex',
                alignItems: 'center',
                gap: '6px',
              }}
            >
              <i className="pi pi-plus" style={{ fontSize: '12px' }} />
              Mais Ações
            </button>
          </div>
        )}
      </div>
    );
  }

  // Legacy layout
  const footer = (
    <Button
      disabled={acoes.length <= 10 || loader >= acoes.length}
      className="buttom-custom"
      icon="pi pi-plus"
      label="Mais Ações"
      onClick={() => { setLoader(loader + 10); ds.current!.load(); }}
    />
  );

  const itemTemplate = (acao: any) => (
    <>
      <div className="grid">
        <div className="col p-fluid flex flex-wrap">
          <div>
            <label className="label-dados">{t('processo')}</label>
            <Chip style={{ width: "100%" }} label={acao.numero} />
          </div>
        </div>
        <div className="col p-fluid flex flex-wrap">
          <div>
            <label className="label-dados">{t('comarca')}</label>
            <Chip style={{ width: "100%" }} label={acao.comarca} />
          </div>
        </div>
      </div>
      <div className="grid">
        <div className="col p-fluid flex flex-wrap">
          <div>
            <label className="label-dados">{t('vara')}</label>
            <Chip style={{ width: "100%" }} label={acao.vara} />
          </div>
        </div>
        <div className="col">
          <div>
            <label className="label-dados">{t('cidadeUF')}</label>
            <Chip style={{ width: "100%" }} label={acao.cidadeUF} />
          </div>
        </div>
      </div>
      <div className="grid">
        <div className="col p-fluid flex flex-wrap">
          <div>
            <label className="label-dados">{t('tipo')}</label>
            <Chip style={{ width: "100%" }} label={acao.tipo} />
          </div>
        </div>
        <div className="col">
          <div>
            <label className="label-dados">{t('Classe Processual')}</label>
            <Chip style={{ width: "100%" }} label={acao.classeProcessual ? acao.classeProcessual : 'Não Informado'} />
          </div>
        </div>
      </div>
      <div className="grid">
        <div className="col p-fluid flex flex-wrap">
          <div>
            <label className="label-dados">{t('valor')}</label>
            <Chip style={{ width: "100%" }} label={acao.valor ? acao.valor : 'Não Informado'} />
          </div>
        </div>
        <div className="col">
          <div>
            <label className="label-dados">{t('origem')}</label>
            <Chip style={{ width: "100%" }} label={acao.origem} />
          </div>
        </div>
      </div>
      <div className="grid">
        <div className="col p-fluid flex flex-wrap">
          <div>
            <label className="label-dados">{t('Código CNJ')}</label>
            <Chip style={{ width: "100%" }} label={acao.classeProcessualCodigoCNJ ? acao.classeProcessualCodigoCNJ : 'Não Informado'} />
          </div>
        </div>
      </div>
      <div className="grid">
        <div className="col p-fluid flex flex-wrap">
          <div>
            <label className="label-dados">{t('dataDistribuicao')}</label>
            <Chip style={{ width: "100%" }} label={acao.dataDistribuicao} />
          </div>
        </div>
        <div className="col p-fluid flex flex-wrap">
          <div>
            <label className="label-dados">{t('dataAutuacao')}</label>
            <Chip style={{ width: "100%" }} label={acao.dataAutuacao ? formatDateToBR(acao.dataAutuacao) : 'Não Informado'} />
          </div>
        </div>
      </div>
      <br></br>
      <DataTable header={t('partes')} size="small" value={acao.partes} tableStyle={{ minWidth: '50rem' }}>
        <Column field="tipo" header={t('tipo')}></Column>
        <Column field="data" header={t('data')}></Column>
        <Column field="polo" header={t('polo')}></Column>
        <Column field="advogado" header={t('advogados')}></Column>
        <Column field="documento" header={t('documento')}></Column>
        <Column field="nome" header={t('nome')}></Column>
      </DataTable>
      <br></br>
      <div className="line"></div>
      <br></br>
    </>
  );

  return (
    <Panel header={t('acoesCompleta')}>
      <div className="flex-consulta flex-wrap gap-3">
        {displayResumos.map((item: any, index: number) => (
          <Card className='flex-1' style={{ backgroundColor: '#2e2eb8' }} key={index}>
            <div className="flex-consulta justify-content-between gap-5">
              <div className="flex-consulta flex-column gap-1">
                <span style={{ color: 'white' }} className="text-sm">{item.label}</span>
                <span style={{ color: 'white' }} className="font-bold text-lg">{item.value}</span>
              </div>
              <span className="w-2rem h-2rem border-circle inline-flex justify-content-center align-items-center text-center" style={{ backgroundColor: 'white', color: '#183462' }}>
                <i className={item.icon} />
              </span>
            </div>
          </Card>
        ))}
      </div>
      <br></br>
      <DataScroller ref={ds} value={acoes} itemTemplate={itemTemplate} rows={10} loader footer={footer} />
    </Panel>
  );
}
